<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" :dark="theme" persistent :max-width="maxWidth">
      <v-card>
        <v-card-actions>
          <v-spacer>
            <v-card-title class="headline">
              {{ title }}
            </v-card-title>
          </v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="close"
            :style="{
              backgroundColor : backgroundFechar ? backgroundFechar : '',
              color: colorFechar ? colorFechar : 'black'
            }"
            v-if="mostraFechar"
           >{{ fechar }}
          </v-btn>
          <slot name="button"></slot>
        </v-card-actions>
        <v-card-text class="ui form" :style="maxHeightModal ? `height: ${maxHeightModal}px;` : ''">
          <span v-if="alertError" class="ui red label">{{ alertError }}</span>
          <slot name="form"></slot>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SimpleModal',
  props: {
    title: {
      type: String,
      default: '',
    },
    alerta: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: Number,
      default: 800,
    },
    fechar: {
      type: String,
      default: 'Cancelar',
    },
    mostraFechar: {
      type: Boolean,
      default: true,
    },
    backgroundFechar: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    colorFechar: {
      type: String,
      default: 'black',
    },
    maxHeightModal: {
      type: Number || null,
      default: null,
    },
  },
  data() {
    return {
      alertError: this.alerta,
      theme: localStorage.getItem('theme') == 'dark' ? 'dark' : false,
    };
  },
  computed: {
    ...mapState('global', {
      showDialog: state => state.modal,
    }),
  },
  methods: {
    close() {
      this.alertError = null;
      this.$store.commit('global/closeModal');
    },
  },
  watch: {
    alerta: {
      immediate: false,
      handler(novo) {
        this.alertError = novo;
      },
    },
  },
};
</script>
